import * as $ from 'jquery'
import * as _ from 'lodash'
import * as Backbone from 'backbone';
const Dropzone = require('dropzone');
import { BaseModifyModalView, BaseModifyModalViewOptions } from "./_BaseModifyModal";
import { callbackify } from 'util';
import { ModuleLayoutCollection } from '../../collections/ModuleLayout';

var template = require('templates/modals/modifyLayout.html');
require('bootstrap-toggle');

interface ModifyLayoutModalOptions extends BaseModifyModalViewOptions {
    installId: number,
    order: number,
    name: string,
    action: string,
}

export class ModifyLayoutModal extends BaseModifyModalView {

    template = _.template(template);
    private currentInstallId: number = null;
    private order: number = 0;
    private name: string;
    private ModuleLayoutCollection: ModuleLayoutCollection;
    private loadedFile;
    private MyDropzone;
    private layoutsOrders = [];
    options: ModifyLayoutModalOptions;

    constructor(options: ModifyLayoutModalOptions) {
        super(<any>_.extend(options, {
            tagName: 'div',
            events: {
                'shown.bs.modal #modifyLayoutModal': 'handleModalShown',
                'hidden.bs.modal #modifyLayoutModal': 'handleModalHidden',
                'click .save-layouts-btn': 'handleSaveLayouts',
                'click .cancel-layout': 'handleCancelLayouts',
                'change #layoutOrder': 'handleCheckFloor',
                'change #layoutName': 'handleCheckFloorName',
            }
        }));
        this.currentInstallId = this.options.installId;
        this.order = this.options.order;
        this.name = this.options.name;
        this.modalIdSelector = 'modifyLayoutModal';
        this.ModuleLayoutCollection = new ModuleLayoutCollection([],this.options.installId)
    }

    render() {
        this.loadModels()

        this.$el.html(this.template({
            currentInstallId: this.currentInstallId,
            layoutOrder: this.order,
            layoutName: this.name
        }));

        return this;
    }

    renderDropzone() {
        var me = this;
        this.MyDropzone = new Dropzone('#svgDropzone', {
            url: '/',
            maxFilesize: 8,
            uploadMultiple: false,
            acceptedFiles: '.pdf,.svg',
            maxFiles: 1,
            addRemoveLinks: true,
            dictDefaultMessage: "Upload your SVG or PDF file here",
            autoProcessQueue: false,
            removedfile: function (file) {
                var _ref;
                return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
            },
            error: function (err) {
                console.log(err)
            },
            success: function () {
            },
            canceled: function () {
                //cancelled files handler
            },
            addedfiles: function (files) {
                // added files handler
            }
        });
    }

    loadModels() {
        $.when(
            this.ModuleLayoutCollection.getCollectionFetchPromise()
        ).then(() => {
            _.each(this.ModuleLayoutCollection.models, (model) => {
                this.layoutsOrders.push(model.get('order'))
            })
        })
    }

    handleCancelLayouts() {
        Backbone.history.loadUrl();
    }

    showLoadedFiles(loadedFile) {
        if (loadedFile) {
            this.loadedFile = loadedFile;
        }
    }

    handleCheckFloor() {
        var value = (Number)($('#layoutOrder').val());
        var exist = _.includes(this.layoutsOrders, value);
        if (exist) {
            $('.floor-error').removeAttr('hidden');
            return false;
        } else {
            $('.floor-error').attr('hidden', 'true');
            return true;
        }
    }

    handleCheckFloorName() {
        var value = (String)($('#layoutName').val());
        if (value && value !== "") {
            $('.floor-name-error').attr('hidden', 'true');
            return true;
        } else {
            $('.floor-name-error').removeAttr('hidden');
            return false;
        }
    }

    handleCheckFileUpload() {
        if (this.options.modelId) {
            return true
        }
        var loadedFile = this.MyDropzone.getAcceptedFiles();
        if (loadedFile.length > 0) {
            $('#emptyFilesMessage').attr('hidden', 'true');
            return true;
        } else {
            $('#emptyFilesMessage').removeAttr('hidden');
            return false;
        }
    }

    show() {
        super.show();
    }

    postInstall(data, currentInstallId, options) {
        var url = window.location.origin + '/api/v1/installs/' + currentInstallId + '/layout'
            + (options.modelId ? '/' + options.modelId : '');
        var type = options.modelId ? 'PUT' : 'POST';
        if (data) {
            $.ajax({
                type: type,
                url: url,
                data: JSON.stringify(data),
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                error: function (request, status, error){
                    console.log(error)
                    $(".floor-upload-error").removeAttr('hidden');
                    $(".modal-form-spinner").addClass('hidden');
                    $(".modal-footer button").removeClass('hidden');
                    throw new Error("The file could not be upload");
                },
                success: function (data, text) {
                    (<any>$('#modifyLayoutModal')).modal('hide')
                    Backbone.history.loadUrl();
                    $(".save-layouts-btn").removeAttr('disabled');
                }
            });
        }
        else {
            $('#emptyFilesMessage').prop('hidden', false)
        }
    }


    saveinstall(callback, currentInstallId, options) {
        var loadedFile = this.MyDropzone.getAcceptedFiles();
        var file = loadedFile[0];
        if (file) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {

                let data = [{
                    name: $('#layoutName').val(),
                    order: $('#layoutOrder').val(),
                    install_id: currentInstallId,
                    module_ui_positions: 0,
                    layout_image: reader.result,
                }];

                callback(data, currentInstallId, options);
            };
            reader.onerror = function (error) {
                (<any>$).notify('The file could not be loaded', 'error');
                throw error;
            };
        } else {
            let data = [{
                name: $('#layoutName').val(),
                order: $('#layoutOrder').val(),
                install_id: currentInstallId,
                module_ui_positions: this.loadedFile.get('module_ui_positions'),
                layout_image: this.loadedFile.get('layout_image')
            }];

            callback(data, currentInstallId, options);

        }
    }

    checkFieldsSaveForUpdate() {
        return this.handleCheckFileUpload() && this.handleCheckFloorName();
    }

    checkFieldsSave() {
        var check = this.handleCheckFileUpload() && this.handleCheckFloorName();
        if (this.options.action === "update") {
            return check;
        } else if (this.options.action === "insert") {
            return check && this.handleCheckFloor();
        }
    }

    handleSaveLayouts() {
        if (this.checkFieldsSave()) {
            try {
                $(".modal-footer button").addClass('hidden');
                $(".modal-form-spinner").removeClass('hidden');
                this.saveinstall(this.postInstall, this.currentInstallId, this.options);
            } catch (e) {
                $(".modal-form-spinner").addClass('hidden');
                $(".modal-footer button").removeClass('hidden');
            }
        }
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/modals/ModifyLayoutModal.ts